/* ============================================================
   sm-hurda-inline.js
   1. teiknarinn opinn strax í síma, restin af síðunni fyrir neðan
   2. plötumyndir forhlaðnar svo efnisskipti séu samstundis
   3. raunmyndagallerí síað eftir völdu efni
   4. Judge.me flotspjaldið tekið úr vegi
   ============================================================ */
(function () {
  var root = document.querySelector('[data-hurda]');
  var mobile = window.innerWidth <= 1000;

  /* ---------- Judge.me flotspjaldið ----------
     Það situr fast við hægri kantinn og liggur yfir efninu. CSS nær
     þekktu nöfnunum; þetta nær hinum, hver sem þau reynast vera. */
  function hideFloatingReviewTabs() {
    var els = document.querySelectorAll('[class*="jdgm"],[id*="jdgm"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed') continue;
      var r = el.getBoundingClientRect();
      if (!r.height || r.width > 140) continue;        /* spjaldið er mjó ræma */
      el.style.setProperty('display', 'none', 'important');
    }
  }
  [0, 900, 2500, 5000].forEach(function (t) { setTimeout(hideFloatingReviewTabs, t); });

  /* ---------- Raunmyndir, síaðar eftir lit ---------- */
  function gallery() {
    var g = document.querySelector('[data-hurda-gallery]');
    if (!g) return;
    var track = g.querySelector('[data-hg-track]');
    var dots = g.querySelector('[data-hg-dots]');
    var iEl = g.querySelector('[data-hg-i]');
    var nEl = g.querySelector('[data-hg-n]');
    var all = Array.prototype.slice.call(g.querySelectorAll('[data-hg-slide]'));
    if (!track || !all.length) return;

    /* Efnismerkið er reiknað í Liquid og skrifað á hvert slide, svo hér
       er borið saman beint, engin giskun út frá skráarnöfnum. */
    var shown = all, lastMat = null, raf = null;

    function build() {
      dots.innerHTML = '';
      for (var i = 0; i < shown.length; i++) {
        var d = document.createElement('span');
        d.className = 'hg-dot' + (i === 0 ? ' on' : '');
        dots.appendChild(d);
      }
      nEl.textContent = shown.length;
      iEl.textContent = shown.length ? 1 : 0;
    }

    function filter(mat) {
      var next = [];
      if (mat) {
        for (var i = 0; i < all.length; i++) {
          if (all[i].getAttribute('data-mat') === mat) next.push(all[i]);
        }
      }
      if (!next.length) next = all;                    /* frekar allt en ekkert */
      for (var j = 0; j < all.length; j++) all[j].hidden = next.indexOf(all[j]) === -1;
      shown = next;
      build();
      track.scrollLeft = 0;
    }

    function sync() {
      if (!shown.length) return;
      var tr = track.getBoundingClientRect();
      var mid = tr.left + tr.width / 2;
      var best = 0, bd = Infinity;
      for (var i = 0; i < shown.length; i++) {
        var r = shown[i].getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bd) { bd = d; best = i; }
      }
      iEl.textContent = best + 1;
      for (var j = 0; j < dots.children.length; j++) {
        dots.children[j].classList.toggle('on', j === best);
      }
    }

    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });

    function currentMat() {
      var a = document.querySelector('.mrail-item.active[data-mat]')
           || document.querySelector('.mat.active[data-mat]');
      return a ? a.getAttribute('data-mat') : null;
    }

    lastMat = currentMat();
    filter(lastMat);

    var rail = document.querySelector('.mrail') || document.querySelector('.mat-groups');
    if (rail && window.MutationObserver) {
      new MutationObserver(function () {
        var m = currentMat();
        if (m !== lastMat) { lastMat = m; filter(m); }
      }).observe(rail, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  if (!root) { gallery(); return; }

  /* ---- Plötumyndirnar forhlaðnar ----
     Forskoðunin skiptir um src þegar efni er valið. Án forhleðslu
     sækir vafrinn myndina í það skiptið og skiptin verða hikandi. */
  (function preloadAtlases() {
    var a = root.attributes;
    for (var i = 0; i < a.length; i++) {
      if (a[i].name.indexOf('data-atlas-') !== 0 || !a[i].value) continue;
      var im = new Image();
      im.decoding = 'async';
      im.src = a[i].value;
    }
  })();

  if (!mobile) {                                       /* á tölvu er teiknarinn þegar opinn */
    gallery();
    /* gildin í fyrirsögnum skrefanna eiga líka við á skjáborði; skjáborðskóðinn
       flytur efnisvalið eftir hleðslu, svo keyrt er aftur nokkrum sinnum */
    [0, 400, 1200, 2500].forEach(function (t) { setTimeout(function () { try { skrefGildi(); } catch (e) {} }, t); });
    return;
  }

  function reveal() {
    var away = document.querySelectorAll('.hs-away');
    for (var i = 0; i < away.length; i++) away[i].classList.remove('hs-away');
  }

  /* padSteps() í steps.js setur allt körfuborðaplássið neðst á skrefin.
     Það pláss á heima neðst á síðunni, ekki milli skrefanna og þess
     sem kemur fyrir neðan, annars myndast eyða í miðri síðu. */
  function trim(steps, bar) {
    if (steps && steps.style.paddingBottom !== '14px') {
      steps.style.setProperty('padding-bottom', '14px', 'important');
    }
    if (bar) {
      var h = Math.round(bar.getBoundingClientRect().height) + 18;
      document.body.style.setProperty('padding-bottom', h + 'px', 'important');
    }
  }

  function findBar() {
    for (var i = 0; i < root.children.length; i++) {
      var el = root.children[i];
      if (el.querySelector && el.querySelector('[data-order-summary]')) return el;
    }
    return null;
  }

  /* Eftir að vöru er bætt í körfu kallar steps.js closeWiz(), sem tekur
     hs-open af body og felur þar með allan teiknarann. Í yfirtökunni var
     það rétt, þá var verið að skila fólki aftur á vörusíðuna. Hér er engin
     yfirtaka og ekkert að loka, svo flaggið er sett jafnóðum aftur á.

     closeWiz skrunar líka á vistaða stöðu, sem er efst á síðunni af því
     umhverfið opnaðist við hleðslu. Skrunstaðan er því geymd áður en
     smellt er og endurheimt í næsta ramma. */
  function keepOpen(bar) {
    if (!window.MutationObserver) return;
    var body = document.body;
    var lastY = 0;

    var addBtn = (bar && bar.querySelector('button'))
             || document.querySelector('.pdp-hurda .checkout [type="submit"]');
    if (addBtn) {
      addBtn.addEventListener('click', function () { lastY = window.scrollY || 0; }, true);
    }

    new MutationObserver(function () {
      if (body.classList.contains('hs-open')) return;
      body.classList.add('hs-open');
      if (bar) bar.style.setProperty('display', 'grid', 'important');
      var y = lastY;
      requestAnimationFrame(function () { window.scrollTo(0, y); });
    }).observe(body, { attributes: true, attributeFilter: ['class'] });
  }

  /* Lysingin undir fyrirsognina.
     Kaflinn sm-hurda-head (.hhead) stendur fyrir ofan brauðmylsnuna og er
     falinn a sima, thvi fyrirsognin hans tvitok .config-header. En lysingin
     hans, .hhead-lede, er su eina a sidunni, og husnumerasidan hefur einmitt
     lysingu undir H1 og ofan vid einkunnina. Hun er thvi faerd thangad.
     Textinn er oskertur ur theminu; hvergi neitt samid her. */
  function ledeIHaus() {
    var lede = document.querySelector('.hhead-lede');
    var head = document.querySelector('.pdp-hurda .config-header');
    if (!lede || !head || head.contains(lede)) return;
    var rating = head.querySelector('.config-rating');
    if (rating) head.insertBefore(lede, rating);
    else head.appendChild(lede);
  }

  /* Nofnin undir fyrirsognina.
     sm-hurda-steps-extra.js byr til div.hs-namebox (nafnareitinn vid hlid
     forskodunarinnar) og skytur honum inn sem beinu barni .config A UNDAN
     .config-header. Maelt: namebox a 432, .config-header a 577. Eigandinn
     vill hausinn og einkunnina fyrst, eins og a husnumerasidunni.
     Adgerdin er sjalfstoduproof: se bunid ad faera haettir hun strax. */
  /* Kaupastikan: SAMA UTLIT, onnur hegdun.
     steps.js byggir stikuna og gefur henni position:fixed med INLINE
     !important, svo hun eltir skrunid alla leid nidur alla siduna.
     Eigandinn vill utlitid oskert - verdid, samantektina a valinu og
     hnappinn - en hegdunina eins og a husnumerasidunni, thar sem
     .hn-checkout er position:sticky; bottom:0 og haettir ad fylgja thegar
     dalkurinn thrytur.

     Inline !important verdur EKKI yfirskrifad ur stilskra, hversu sertaek
     sem reglan er; thad verdur bara yfirskrifad med odru inline !important.
     Thess vegna er thetta gert her en ekki i CSS.

     left/right eru hreinsud: thau eiga adeins vid um fasta stadsetningu og
     myndu annars gera stikuna larett-lima. padding-bottom a body var
     plassid undir fostu stikuna og a ekki lengur vid. */
  function stikanLimd(bar) {
    if (!bar) return;
    bar.style.setProperty('position', 'sticky', 'important');
    bar.style.setProperty('bottom', '0', 'important');
    bar.style.removeProperty('left');
    bar.style.removeProperty('right');
    document.body.style.removeProperty('padding-bottom');
  }

  /* Hvar stikan a ad SLEPPA.
     position:sticky; bottom:0 heldur stakinu vid nedri brun gluggans thangad
     til natturuleg stada thess naest, og su stada er thar sem thad liggur i
     flaedinu. Stikan var sidasta barn .pdp-hurda, svo hun slappti ekki fyrr
     en allur stillibunadurinn var lidinn, thar med talid traustrodin og
     greidslumerkin. Eigandinn vill ad hun stoppi fyrir nedan magnid.

     .hs-steps endar a sidasta skrefinu, sem er "Athugasemd" med .hs-qty
     nedst. Stikan er thvi faerd thangad, sem naest systkini a eftir
     .hs-steps. Formid ber ekkert hlidarspassiu (padding 0 !important), svo
     stikan heldur fullri breidd; .hs-steps sjalfur hefdi threngt hana um
     15px hvoru megin. Sjalfstoduproft: haettir strax se bunid ad faera. */
  function stikaEftirMagn(bar) {
    if (!bar) return;
    var steps = document.querySelector('.pdp-hurda .hs-steps');
    if (!steps || !steps.parentNode) return;
    if (bar.previousElementSibling === steps) return;
    steps.parentNode.insertBefore(bar, steps.nextSibling);
  }

  function nafnUndirHaus() {
    var nb = document.querySelector('.pdp-hurda .config > .hs-namebox');
    var head = document.querySelector('.pdp-hurda .config > .config-header');
    if (!nb || !head || nb.previousElementSibling === head) return;
    head.parentNode.insertBefore(nb, head.nextSibling);
  }

  /* ---------- Útlit eins og á krossaskiltasíðunni ----------
     Stikan er smíðuð af steps.js með innfelldum !important stílum, svo
     lögun hennar breytist aðeins hér. Litina (grátt óvirkt, appelsínugult
     virkt) setur steps.js áfram og þeir passa þegar. */
  function stikaUtlit(bar) {
    if (!bar) return;
    /* sama stika og á krossaskiltasíðunni: „Heildarverð“ yfir verðinu og
       hnappurinn fyllir restina. Samantektin og „Frí heimsending“ víkja. */
    [['padding', '10px 16px calc(10px + env(safe-area-inset-bottom))'], ['gap', '14px'],
     ['grid-template-columns', 'auto minmax(0, 1fr)'], ['background', 'rgba(255, 255, 255, 0.96)'],
     ['border-top', '1px solid var(--rule)']].forEach(function (p) {
      bar.style.setProperty(p[0], p[1], 'important');
    });
    var samantekt = bar.querySelector('[data-order-summary]');
    if (samantekt) samantekt.style.setProperty('display', 'none', 'important');
    var btn = bar.querySelector('button');
    if (btn) {
      btn.style.setProperty('justify-self', 'stretch', 'important');
      btn.style.setProperty('justify-content', 'center', 'important');
      [['border-radius', '999px'], ['min-height', '52px'], ['padding', '0 22px'],
       ['font-family', 'var(--font-body)'], ['font-weight', '600'], ['font-size', '16px'],
       ['letter-spacing', '0'], ['text-transform', 'none']].forEach(function (p) {
        btn.style.setProperty(p[0], p[1], 'important');
      });
    }
    var verd = bar.querySelector('[data-mprice]');
    if (verd) {
      verd.style.setProperty('font-size', '22px', 'important');
      verd.style.setProperty('letter-spacing', '-0.02em', 'important');
      verd.style.setProperty('white-space', 'nowrap', 'important');
      var lina = verd.parentElement;
      if (lina) {
        [].forEach.call(lina.children, function (el) {
          if (el !== verd) el.style.setProperty('display', 'none', 'important');
        });
        if (!bar.querySelector('.u-bar-lbl')) {
          var lbl = document.createElement('small');
          lbl.className = 'u-bar-lbl';
          lbl.textContent = 'Heildarverð';
          [['display', 'block'], ['font-family', 'var(--font-mono)'], ['font-size', '10.5px'],
           ['line-height', '1.2'], ['letter-spacing', '0.14em'], ['text-transform', 'uppercase'],
           ['color', 'var(--ink-mute)']].forEach(function (p) { lbl.style.setProperty(p[0], p[1], 'important'); });
          lina.parentNode.insertBefore(lbl, lina);
        }
      }
    }
  }

  /* steps.js skrifar "Slaðu inn nafn" (vantar kommuna); leiðrétt jafnóðum */
  function sladu(bar) {
    var btn = bar && bar.querySelector('button');
    if (!btn || !window.MutationObserver) return;
    function laga() {
      var w = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        if (n.nodeValue.indexOf('Slaðu') > -1) n.nodeValue = n.nodeValue.replace('Slaðu', 'Sláðu');
      }
    }
    laga();
    new MutationObserver(laga).observe(btn, { childList: true, subtree: true, characterData: true });
  }

  /* valið gildi hægra megin í fyrirsögn hvers skrefs, eins og á krossaskiltasíðunni */
  var gildiBundid = false;
  function skrefGildi() {
    var cfg = document.querySelector('.pdp-hurda');
    if (!cfg) return;
    function setja(titill, texti) {
      if (!titill) return;
      var s = titill.querySelector('.u-val');
      if (!s) { s = document.createElement('span'); s.className = 'u-val'; titill.appendChild(s); }
      if (s.textContent !== texti) s.textContent = texti;
    }
    /* fyrirsögnin sem á við reitinn: sú næsta á undan honum. Á skjáborði
       eru nöfn og stærð í sama skrefi, svo fyrsta fyrirsögn skrefsins dugar ekki. */
    function titillFyrir(el) {
      for (var p = el.previousElementSibling; p; p = p.previousElementSibling) {
        if (p.classList && p.classList.contains('hs-step-title')) return p;
      }
      var s = el.closest('.hs-namebox, .hs-step');
      return s ? s.querySelector('.hs-step-title') : null;
    }
    function uppfaera() {
      var nofn = cfg.querySelector('[data-names]');
      if (nofn) {
        var n = nofn.value.split('\n').filter(function (l) { return l.trim(); }).length;
        setja(titillFyrir(nofn), n === 0 ? '' : n === 1 ? '1 nafn' : n + ' nöfn');
      }
      var efni = cfg.querySelector('[data-mat-info-name]');
      var mrail = cfg.querySelector('.mrail');
      if (mrail) {
        /* á skjáborði er efnisvalið, með fyrirsögn sinni, flutt í vinstri dálkinn */
        var mt = null;
        for (var c = mrail.firstElementChild; c; c = c.nextElementSibling) if (c.classList.contains('hs-step-title')) mt = c;
        setja(mt || titillFyrir(mrail), efni ? efni.textContent.trim() : '');
      }
      var rod = cfg.querySelector('.size-row');
      if (rod) { var a = rod.querySelector('.size.active .size-dim'); setja(titillFyrir(rod), a ? a.textContent.trim() : ''); }
      var let_ = cfg.querySelector('.font-row');
      if (let_) { var f = let_.querySelector('.fontbtn.active .fontbtn-name'); setja(titillFyrir(let_), f ? f.textContent.trim() : ''); }
    }
    uppfaera();
    if (gildiBundid) return;
    gildiBundid = true;
    var bid = null;
    function seinna() { if (bid) cancelAnimationFrame(bid); bid = requestAnimationFrame(uppfaera); }
    cfg.addEventListener('click', seinna);
    cfg.addEventListener('input', seinna);
    if (window.MutationObserver) {
      new MutationObserver(seinna).observe(cfg, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
  }

  function go() {
    /* Galleríið fyrst og sér: kasti eitthvað í teiknaranum hér fyrir neðan
       má það ekki taka myndirnar með sér. */
    try { gallery(); } catch (e) {}
    try { skrefGildi(); } catch (e) {}
    /* skjáborðskóðinn flytur efnisvalið eftir að þetta keyrir fyrst */
    [400, 1200, 2500].forEach(function (t) { setTimeout(function () { try { skrefGildi(); } catch (e) {} }, t); });

    var trigger = document.querySelector('[data-hs-open]');
    if (!trigger) return;

    trigger.click();                                   /* lætur steps.js stilla upp teiknaranum */
    reveal();                                          /* en ekkert er falið */

    /* .hs-intro er falin í CSS: myndirnar komnar í sm-hurda-gallery og
       textinn í sm-hurda-about, svo þar stendur ekkert eftir. */
    var openbar = document.querySelector('.hs-open-bar');
    if (openbar && openbar.parentNode) openbar.parentNode.removeChild(openbar);

    var steps = root.querySelector('.hs-steps');

    var bar = findBar();
    stikanLimd(bar);
    stikaUtlit(bar);
    sladu(bar);

    /* Keyrt nokkrum sinnum: .hs-namebox er smidadur af
       sm-hurda-steps-extra.js og getur komid eftir ad thetta keyrir fyrst.
       Badar adgerdirnar eru sjalfstoduproofar, svo endurtekningin kostar
       ekkert og engin their vinnur gegn hinni. */
    [0, 250, 900, 2500].forEach(function (t) {
      setTimeout(function () { ledeIHaus(); nafnUndirHaus(); stikaEftirMagn(bar); try { skrefGildi(); } catch (e) {} }, t);
    });

    trim(steps, null);
    keepOpen(bar);
    if (steps && window.MutationObserver) {
      new MutationObserver(function () { trim(steps, null); })
        .observe(steps, { attributes: true, attributeFilter: ['style'] });
    }
    window.addEventListener('resize', function () { trim(steps, null); });

    window.dispatchEvent(new Event('resize'));
  }

  function start() { setTimeout(function () { try { go(); } catch (e) { try { gallery(); } catch (e2) {} } }, 0); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
